import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons"

import * as classes from "./Tooltip.module.css"

const Tooltip = (props) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false)
  const tooltipHandler = () => {
    setTooltipIsOpen((prevState) => !prevState)
  }
  const closeTooltipHandler = () => {
    setTooltipIsOpen(false)
  }
  return (
    <>
      <button
        className={classes.tooltipButton}
        onClick={tooltipHandler}
        onBlur={closeTooltipHandler}
        type="button"
        aria-haspopup="true"
        aria-expanded={tooltipIsOpen}
        aria-controls="popup"
      >
        {props.buttonName}
        <FontAwesomeIcon
          icon={tooltipIsOpen ? faAngleUp : faAngleDown}
          fixedWidth
        />
      </button>
      {tooltipIsOpen && (
        <div id="popup" className={classes.tooltip}>
          {props.children}
        </div>
      )}
    </>
  )
}

export default Tooltip
